import * as React from 'react';

import { HeaderProps, useController } from './header.controller';
import { Cell } from './components/cell';
import { NewTableColumn, NewTableDefaultDataItem } from '@common/components/new-table/new-table.types';
import { getTestAttributes } from '@common/utils/tests';

import './header.styles.scss';

export const Header: React.FC<HeaderProps> = (props) => {
  const { model, loading, loadTableMetadata, columns, currentColumnResizeOffset, getId, onColumnResizeEnd } = props;
 
  const {
    handleSort,
    handleCellContextMenu,
    handleHeaderContextMenu,
    handleColumnDrop,
  } = useController(props);

  return (
    <thead className="NewTable__header">
      {model.map((headerGroup) => (
        <tr 
          key={headerGroup.id}
          onContextMenu={handleHeaderContextMenu}
          {...getTestAttributes({ id: getId.header() })}
        >
          {headerGroup.headers.map((headerCell, index) => {
            return (
              <Cell 
                loading={loading}
                key={headerCell.id}
                getId={{
                  root: getId.headerCell(headerCell.column as unknown as NewTableColumn<NewTableDefaultDataItem>, index)
                }}
                headerCell={headerCell}
                loadTableMetadata={loadTableMetadata} 
                columns={columns}
                currentColumnResizeOffset={currentColumnResizeOffset}
                onContextMenu={handleCellContextMenu}
                onColumnResizeEnd={onColumnResizeEnd}
                onSort={handleSort}
                onDrop={handleColumnDrop}
              />
            );
          })}
        </tr>
      ))}
    </thead>
  );
};